export default __webpack_public_path__ + "static/11-c5cda5ea33dc74f7e1cae2804ef457f9.webp";